import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Alert } from '@grandvisionhq/iris-ui';
import { Modal } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';
import { pushStoreFiltersModalClickEvent, pushStoreFiltersModalCloseEvent } from '../../data-layer/storeFilters.js';
import StoreFilters from '../StoreFilters/StoreFilters.js';

const StoreFiltersModal = ({ isOpen , onModalClose , filters , appliedFilters , hasAppliedFilters , toggleFilter , resultsCount , isLoadingResults , clearFilters  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const labels = {
        cta: getLabel('stores.storeFilters.cta'),
        headerButton: getLabel('stores.storeFilters.modal.clearAll'),
        close: getLabel('stores.storeFilters.modal.close'),
        viewXResults: getFormattedLabel('stores.storeFilters.modal.viewXResults', {
            labelData: {
                count: `${resultsCount}`
            }
        }),
        noResults: getLabel('stores.storeFilters.modal.noResults')
    };
    const showResults = hasAppliedFilters && resultsCount > 0;
    const buttonCaption = showResults ? labels.viewXResults : labels.close;
    const onHandleSubmit = ()=>{
        if (showResults) {
            pushStoreFiltersModalClickEvent({
                eventName: 'store_filters_click',
                interactionType: 'filter_stores_view_stores',
                listOfSelectedFilters: Object.keys(appliedFilters).map((key)=>{
                    return appliedFilters[key].map((filter)=>`${key}:${filter}`
                    );
                }).flat(),
                availableStores: resultsCount
            });
        } else {
            pushStoreFiltersModalCloseEvent({
                eventName: 'store_filters_click',
                interactionType: 'store_filters_close',
                closeOption: 'go_back_option'
            });
        }
        onModalClose();
    };
    const onHandleBackIconClick = ()=>{
        pushStoreFiltersModalCloseEvent({
            eventName: 'store_filters_click',
            interactionType: 'store_filters_close',
            closeOption: 'arrow_option'
        });
    };
    const onHandleRandomClick = ()=>{
        pushStoreFiltersModalCloseEvent({
            eventName: 'store_filters_click',
            interactionType: 'store_filters_close',
            closeOption: 'random_click_option'
        });
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isOpen,
        onModalClose: onModalClose,
        showBackButton: true,
        additionalEventsWithBackIcon: onHandleBackIconClick,
        additionalEventsWithRandomAreaClick: onHandleRandomClick,
        title: labels.cta,
        headerTextButtonProps: {
            label: labels.headerButton,
            onClick: clearFilters,
            isDisabled: !hasAppliedFilters
        },
        footer: showResults || isLoadingResults || !hasAppliedFilters ? /*#__PURE__*/ React.createElement(Button, {
            caption: buttonCaption,
            variant: showResults ? 'solid' : 'outline',
            className: "store-filters-modal__footer-button",
            onClick: onHandleSubmit,
            isLoading: isLoadingResults
        }) : /*#__PURE__*/ React.createElement(Alert, {
            variant: "warning",
            className: "alert-m-default store-filters-modal__footer-alert"
        }, labels.noResults)
    }, /*#__PURE__*/ React.createElement(StoreFilters, {
        filters: filters,
        appliedFilters: appliedFilters,
        toggleFilter: toggleFilter,
        isLoadingResults: isLoadingResults
    }));
};

export { StoreFiltersModal as default };
//# sourceMappingURL=StoreFiltersModal.js.map
